import { parseCurrencyInputToNumber } from 'utils/currencyFormat';
import {
  DISCOUNT_TYPE,
  VOUCHER_APPLY_TYPE,
  isBookeseDiscountUseType,
  isBookesePublicUseType,
} from 'constants/voucherCampaign';

const toIsoString = (value) => {
  if (!value) return undefined;
  if (value instanceof Date) return value.toISOString();
  return value;
};

const toOptionalPositiveNumber = (value) => {
  const numberValue = parseCurrencyInputToNumber(value);
  return numberValue === undefined ? undefined : numberValue;
};

export const buildVoucherCampaignPayload = (values) => {
  const useType = values.voucherType;
  const isPublic = isBookesePublicUseType(useType);

  const payload = {
    name: values.campaignName?.trim(),
    useType,
    startAt: toIsoString(values.startAt),
  };

  const endAt = toIsoString(values.endAt);
  if (endAt) {
    payload.endAt = endAt;
  }

  if (!isPublic) {
    payload.voucherExpiryAt = toIsoString(values.voucherExpiredAt);
  }

  if (isBookeseDiscountUseType(useType)) {
    payload.discountType = values.discountType;
    payload.discountValue = parseCurrencyInputToNumber(values.discountValue);

    if (values.discountType === DISCOUNT_TYPE.PERCENT) {
      const maxDiscountAmount = toOptionalPositiveNumber(values.maxDiscountAmount);
      if (maxDiscountAmount !== undefined) {
        payload.maxDiscountAmount = maxDiscountAmount;
      }
    }
  }

  if (isPublic) {
    payload.code = values.code?.trim();
    payload.totalVoucher = Number(values.totalVoucher);
    payload.applyType = values.applyType;

    const maxUsesPerUser = toOptionalPositiveNumber(values.maxUsesPerUser);
    if (maxUsesPerUser !== undefined) {
      payload.maxUsesPerUser = maxUsesPerUser;
    }

    if (values.applyType === VOUCHER_APPLY_TYPE.MIN_BOOKING_AMOUNT) {
      payload.minBookingAmount = parseCurrencyInputToNumber(
        values.minBookingAmount,
      );
    }
  }

  return payload;
};

export const mapCampaignResponseToForm = (data = {}) => ({
  campaignName: data.name || '',
  voucherType: data.useType || '',
  discountType: data.discountType || '',
  discountValue: data.discountValue ?? '',
  maxDiscountAmount: data.maxDiscountAmount ?? '',
  code: data.code || data.vouchers?.[0]?.code || '',
  totalVoucher: data.totalVoucher ?? '',
  maxUsesPerUser: data.maxUsesPerUser ?? '',
  applyType: data.applyType || '',
  minBookingAmount: data.minBookingAmount ?? '',
  startAt: data.startAt ? new Date(data.startAt) : null,
  endAt: data.endAt ? new Date(data.endAt) : null,
  voucherExpiredAt: data.voucherExpiryAt ? new Date(data.voucherExpiryAt) : null,
});

export const mapVouchersToTableRows = (vouchers = [], campaign = {}) => (
  vouchers.map((voucher, index) => ({
    _id: voucher._id || voucher.id || `${voucher.code || 'voucher'}-${index}`,
    code: voucher.code,
    voucherType: voucher.useType || campaign.useType,
    startAt: voucher.startAt || campaign.startAt,
    endAt: voucher.endAt || campaign.endAt,
    voucherExpiredAt: voucher.voucherExpiryAt
      || voucher.voucherExpiredAt
      || campaign.voucherExpiryAt,
  }))
);
